import { z } from 'zod';

export const MessageServices = z.enum(
  [
    '0-default',
    '1-full-wallet-profile',
    '2-wallet-kyc',
    '3-analyze-txn-trace-call',
    '4-full-txn-decode',
    '5-full-contract-analysis',
    '6-tracer-next-node',
    '7-analyze-current-page',
    '8-heatmap-analysis',
  ],
  {
    description: 'Service to use for AI.',
  }
);
